import React from "react";
import Button from "../../central/Button";
import Dropdown from "../../central/Dropdown";
import { OWN_GOAL_ID } from "../../utils/matchConstants";

const GoalStep = ({ players, goals, setGoals, appearanceData = {} }) => {
  const dropdownTightStyle = {
    width: "100%",
    minWidth: 0,
  };
  // update a scorer/assist in a given goal
  const handleGoalChange = (index, field, value) => {
    const updated = [...goals];
    const normalizedValue = value?.value || value; // ensure we only store a string
    updated[index] = { ...updated[index], [field]: normalizedValue };
    setGoals(updated);
  };

  const addGoal = () => {
    setGoals([...goals, { scorer: "", assist: "" }]);
  };

  const removeGoal = (index) => {
    const updated = [...goals];
    updated.splice(index, 1);
    setGoals(updated);
  };

  // filter players who appeared, robustly checking appearanceData
  const appearedPlayers = players.filter(
    (p) => appearanceData[p.id]?.appeared
  );

  return (
    <div>
      <style>{`
        .goalRowGrid {
          display: grid;
          grid-template-columns: minmax(0, 1fr) 32px;
          grid-template-areas:
            "scorer remove"
            "assist remove";
          gap: 10px;
          align-items: center;
          margin-bottom: 10px;
        }

        .goalField {
          display: flex;
          align-items: center;
          gap: 6px;
          min-width: 0;
        }

        .goalLabel {
          font-weight: 600;
          white-space: nowrap;
        }

        .goalRemoveBtn {
          justify-self: center;
          align-self: center;
          background: transparent;
          border: 1px solid #ccc;
          border-radius: 50%;
          width: 28px;
          height: 28px;
          line-height: 26px;
          text-align: center;
          cursor: pointer;
          font-size: 16px;
          color: #666;
        }

        .goalFieldScorer {
          grid-area: scorer;
        }

        .goalFieldAssist {
          grid-area: assist;
        }

        .goalRemoveWrap {
          grid-area: remove;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}</style>
      <div
        style={{
          fontStyle: "italic",
          marginBottom: 8,
          fontSize: "0.9em",
        }}
      >
        Add goals and assists

      </div>
      {appearedPlayers.length === 0 ? (
        <p style={{ color: "red" }}>
          No players available — mark appearances first.
        </p>
      ) : (
        <>
          {goals.map((g, idx) => (
            <div key={idx} className="goalRowGrid">
              <div className="goalField goalFieldScorer">
                <span className="goalLabel">Scorer:</span>
                <Dropdown
                  value={g.scorer}
                  onChange={(value) => handleGoalChange(idx, "scorer", value)}
                  options={[
                    { label: "Select", value: "" },
                    { label: "Own Goal (opposition)", value: OWN_GOAL_ID },
                    ...appearedPlayers.map((p) => ({
                      label: `${p.name} (${p.position})`,
                      value: p.id,
                    })),
                  ]}
                  containerStyle={dropdownTightStyle}
                />
              </div>

              <div className="goalField goalFieldAssist">
                <span className="goalLabel">Assist:</span>
                <Dropdown
                  value={g.assist}
                  onChange={(value) => handleGoalChange(idx, "assist", value)}
                  options={[
                    { label: "None", value: "" },
                    ...appearedPlayers
                      .filter((p) => p.id !== g.scorer)
                      .map((p) => ({
                        label: `${p.name} (${p.position})`,
                        value: p.id,
                      })),
                  ]}
                  containerStyle={dropdownTightStyle}
                />
              </div>

              <div className="goalRemoveWrap">
                <button
                  type="button"
                  onClick={() => removeGoal(idx)}
                  aria-label="Remove goal"
                  className="goalRemoveBtn"
                >
                  ×
                </button>
              </div>
            </div>
          ))}
          <div style={{ marginTop: "10px" }}>
            <Button onClick={addGoal} variant="blue">
              Add Goal
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default GoalStep;